

















































































import { Component, Vue } from 'vue-property-decorator';
import ContactDialog from '@/components/crm/ContactDialog.vue';
import { DxLookup } from 'devextreme-vue/lookup';
import { DxPopup } from 'devextreme-vue/popup';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';
import ContactPricingAgreementCard from '@/components/crm/shared/ContactPricingAgreementCard.vue';
import projectOverviewCard from '@/components/projects/projectsOverviewCard.vue';

import { DxForm, DxLabel, DxSimpleItem } from 'devextreme-vue/form';

import { DxDataGrid, DxColumn, DxEditing, DxStateStoring, DxSearchPanel } from 'devextreme-vue/data-grid';

import { DxHtmlEditor, DxToolbar, DxItem } from 'devextreme-vue/html-editor';

import { DxCheckBox } from 'devextreme-vue/check-box';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { AddressType, Contact, ContactsClient } from '@/data/web-api-client';
import notificationService from '@/services/notificationService';
import BillingDetailsCard from '@/components/crm/shared/BillingDetailsCard.vue';

@Component({
  components: {
    cDatagrid,
    DxSimpleItem,
    DxForm,
    DxLabel,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring,
    DxSearchPanel,
    DxLookup,
    DxPopup,
    DxHtmlEditor,
    DxToolbar,
    DxItem,
    ContactDialog,
    DxSelectBox,
    DxCheckBox,
    cCard,
    ContactPricingAgreementCard,
    projectOverviewCard,
    BillingDetailsCard,
  },
})
export default class ContactDetails extends Vue {
  showContactsDialog: boolean = false;
  contact?: Contact = undefined;
  loading: boolean = true;

  addressTypes: any[] = [
    { value: 0, text: 'Standaard' },
    { value: 1, text: 'Leveradres' },
    { value: 2, text: 'Factuur adres' },
    { value: 3, text: 'Bezoek adres' },
  ];

  public getAddressType(type: AddressType | undefined) {
    if (type != null || type != undefined) {
      return this.addressTypes.find((addressType: any) => addressType.value === type).text;
    }

    return '';
  }

  get routeId() {
    return this.$route.params.id;
  }

  public showContactInfoPopup() {
    this.showContactsDialog = true;
  }

  public async mounted() {
    await this.loadData();
  }

  public async loadData() {
    this.loading = true;
    await this.getContact();
    this.loading = false;
  }

  editContact() {
    const dialog = this.$refs.ContactDialog as ContactDialog;
    dialog.show = true;
    dialog.contactId = this.contact!.id as string;
  }

  private async getContact() {
    const contact = await new ContactsClient(undefined, this.$axios).get2(this.$route.params.id).catch((error) => notificationService.failedToLoad());
    if (contact instanceof Contact) this.contact = contact;
  }
}
